import { all } from '@wrisk/styled-system'

const allowedProps = ['data-testid']

export const defaultConfig = {
  shouldForwardProp: (prop, defaultValidatorFn) =>
    defaultValidatorFn(prop) &&
    (!all.propNames?.includes(prop) || allowedProps.includes(prop)),
}
